export default {
    inject: ['page'],
    computed: {
        leilao () {
            return this.page.leilao
        }
    }
}
